import { SAVED_FILTER_SET_TYPES } from '@linearb/linjs-common';
import { FILTER_TYPES } from 'common/constants/filters';
import { getIssueTypesByIds } from 'common/services/pm-projects-filters.service';
import { cloneDeep, flatMap, keyBy, omit, pick } from 'lodash';

export const getFilterSetTypeText = filterSet => {
  switch (filterSet.type) {
    case SAVED_FILTER_SET_TYPES.PROJECT:
      return 'Project';
    case SAVED_FILTER_SET_TYPES.FILTER_SET:
      return 'Filter Set';
    default:
      return 'N/A';
  }
};

export const syncFiltersByTreeHierarchy = async (
  filters,
  isTreeHierarchyEnabled,
  pmSensorAuthId
) => {
  const oldParentsIssues = flatMap(
    pick(filters, [FILTER_TYPES.ISSUE_PARENT_1, FILTER_TYPES.ISSUE_PARENT_2])
  );
  const isOldParentsIssuesExists = oldParentsIssues?.length > 0;

  let syncedFilters = cloneDeep(filters);

  if (isTreeHierarchyEnabled) {
    if (isOldParentsIssuesExists) {
      const oldParentIssuesIds = oldParentsIssues
        .map(issue => issue?.id)
        .filter(Boolean);
      const oldIssuesEntitiesTypesRes = await getIssueTypesByIds({
        sensor_authorization_id: pmSensorAuthId,
        issues_ids: oldParentIssuesIds
      });
      const oldIssuesEntityTypeById = keyBy(
        oldIssuesEntitiesTypesRes.items,
        'issue_provider_id'
      );

      const syncedOldParentIssues = oldParentsIssues.map(issue => {
        const entityType = oldIssuesEntityTypeById[issue?.id]?.issue_type;
        return {
          ...issue,
          entity_type: entityType || 'N/A'
        };
      });

      const syncedDynamicIssues = [
        ...(filters?.[FILTER_TYPES.DYNAMIC_ISSUES] || []),
        ...(syncedOldParentIssues || [])
      ];

      syncedFilters = {
        ...syncedFilters,
        ...(syncedDynamicIssues?.length > 0 && {
          [FILTER_TYPES.DYNAMIC_ISSUES]: syncedDynamicIssues
        })
      };

      syncedFilters = omit(syncedFilters, [
        FILTER_TYPES.ISSUE_PARENT_1,
        FILTER_TYPES.ISSUE_PARENT_2
      ]);
    }
  } else {
    syncedFilters = omit(syncedFilters, [FILTER_TYPES.DYNAMIC_ISSUES]);
  }

  return syncedFilters;
};
